import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import Select from "react-select";
import httpService from "../../../services/http/sales/sales.service";
import usePagination, {
    createInitialPagination,
} from "../../../custom-hooks/usePagination";
import UnlimitTable from "../../../components/ui-kit/unlimit-table";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useRoleAndPerm from "../../../utils/permissionFunction";
import { useSelectedCountry } from "../../../feature-module/dashboard/hooks/useSelectedCountry";
import formatNumber from "../../../utils/numberFunction";
const SalesList = () => {
    const { hasPermission } = useRoleAndPerm();
    const [nameFilter, setNameFilter] = useState("");
    const [saleIdFilter, setSaleIdFilter] = useState("");
    const [lmUserIdFilter, setLmUserIdFilter] = useState("");
    const [lmAccountNoFilter, setLmAccountNoFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [designations, setDesignations] = useState([]);
    const selectedCountry = useSelectedCountry();
    const [company, setCompany] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const companies = useSelector((state) => state.companies.companies);
    const { t } = useTranslation();
    const initialPagination = createInitialPagination(t);
    const { paginationParams, updatePaginationParams } =
        usePagination(initialPagination);


    const getPurchaseList = async (
        pagination = paginationParams.pagination,
        filters,
        sorter = {}
    ) => {
        const data = {
            page: pagination?.current ?? 1,
            per_page: pagination?.pageSize ?? 10,
            company_id: selectedCompany.value,
            ...filters,
            ...sorter,
        };
        setLoading(true);
        await httpService
            .salesList(data)
            .then((response) => {
                if (response.status == 200) {
                    setDesignations(response.data.data?.data);
                }
                updatePaginationParams({
                    pagination: {
                        ...paginationParams.pagination,
                        current: response.data.data.current_page,
                        total: response.data.data.total,
                        pageSize: response.data.data.per_page,
                    },
                });
            })
            .catch((error) => {
                console.error("Error:", error);
                updatePaginationParams({
                    pagination: {
                        ...paginationParams.pagination,
                    },
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleTableChange = async (pagination, filters, sorter) => {
        filters = {
            shopper_name: nameFilter,
            id: saleIdFilter,
            lm_shopper_number: lmUserIdFilter,
            lm_account_number: lmAccountNoFilter,
        };

        const nonNullFilters = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => !!value)
        );
        if (sorter && sorter.field) {
            sorter = {
                sort_by: sorter.field,
                sort_direction: sorter.order == "ascend" ? "ASC" : "DESC",
            };
        }
        if (!pagination) {
            pagination = initialPagination;
        }
        await updatePaginationParams({
            pagination,
            sorter,
        });
        await getPurchaseList(pagination, nonNullFilters, sorter);
    };
    
    useEffect(() => {
        if (selectedCompany?.value) {
            handleTableChange();
        }
    }, [selectedCompany]);
    useEffect(() => {
        setCompany(companies?.data?.data);
        let selectedCompany = companies?.data?.data[0];

        if (companies?.data?.data?.length) {
            const company = companies.data.data.find((company) =>
                company.business_name.toLowerCase().includes("near")
            );
            if (company) {
                selectedCompany = company;
            }
        }

        setSelectedCompany({
            ...selectedCompany,
            value: selectedCompany?.id,
            label: selectedCompany?.business_name,
        });
    }, []);
    const columns = [
        {
            title: t("tableColumnName.srNo"),
            dataIndex: "index",
            align: "center",
            render: (value, item, index) =>
                (paginationParams?.pagination?.current - 1) *
                paginationParams?.pagination?.pageSize +
                (index + 1),
        },
        {
            title: t("Sales.SalesID"),
            dataIndex: "order_code",
            render: (text, record) => {
                return record?.order_code ?? "";
            },
        },
        {
            title: t("inputField.label.lmUserID"),
            dataIndex: "lm_shopper_number",
            render: (text, record) => {
                return record?.shopper?.lm_shopper_number ?? "";
            },
        },
        {
            title: t("Sales.shopperName"),
            dataIndex: "shopper",
            render: (text, record) => {
                return record?.shopper?.name ?? "";
            },
        },
        {
            title: t("tableColumnName.lmAccountNo"),
            dataIndex: "lm_account_no",
            render: (text, record) => {
                return record?.company_account?.lm_account_number ?? "";
            },
        },
        {
            title: t("tableColumnName.userReference"),
            dataIndex: "reference",
        },
        {
            title: t("logs.date"),
            dataIndex: "created_at",
            render: (text) => {
                return text ? moment(text).format("DD MMM YYYY - HH:mm:ss") : "";
            },
        },
        {
            title: t("shop.shop"),
            dataIndex: "outlet",
            hidden: false,
            render: (text, record) => (
                <div className="d-flex align-items-center">
                    <ImageWithBasePath
                        type="link"
                        src={record.outlet?.image_url}
                        alt="Contact"
                        style={{ width: 30, height: 30, marginRight: 10 }}
                    />
                    {record?.outlet?.name}
                </div>
            ),
        },
        {
            title: t("tableColumnName.actions"),
            key: "actions",
            hidden: !hasPermission(["sale-view"]),
            render: (text, record) => (
                <div className="action-table-data">
                    <div className="edit-delete-action">
                        {hasPermission(["sale-view"]) && (
                            <Link
                                to={`/sales/${record.id}/details`}
                                className="me-2 edit-icon p-2"
                            >
                                <i className="feather-eye"></i>
                            </Link>
                        )}
                    </div>
                </div>
            ),
        },
    ];
    const breadcrumbItems = [
        { label: "", link: "/", icon: "feather-home" },
        { label: t("Sales.saleOrders"), active: true },
    ];
    const companyOptions = company?.map((company) => ({
        ...company,
        value: company.id,
        label: company.business_name,
    }));
    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex flex-column">
                            <div className="page-title">
                                <h4>{t("Sales.saleOrders")}</h4>
                            </div>
                            <UnlimitBreadcrumb items={breadcrumbItems} />
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="row" style={{ padding: "24px 24px 0" }}>
                                <div className="mb-0 col-lg-5 col-sm-5 col-12">
                                    <div className="unlimit-uikit-select">
                                        <label className="mb-2">{t("company.company")}</label>
                                        <Select
                                            options={companyOptions}
                                            className="select custom-select"
                                            placeholder={t("inputField.placeholder.chooseCompany")}
                                            value={selectedCompany}
                                            formatOptionLabel={({ label, logo_url }) => (
                                                <div className="d-flex">
                                                    <img
                                                        src={logo_url}
                                                        alt=""
                                                        style={{
                                                            width: 20,
                                                            height: 20,
                                                            marginRight: 10,
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                    <span style={{ marginLeft: 10 }}>{label}</span>
                                                </div>
                                            )}
                                            onChange={(selectedOption) =>
                                                setSelectedCompany(selectedOption)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="table-top row">
                                <div className="col-lg-3 col-12">
                                    <input
                                        type="text"
                                        placeholder={t("inputField.placeholder.enterSalesID")}
                                        className="form-control form-control-sm formsearch-custom ps-2"
                                        value={saleIdFilter}
                                        onChange={(e) => setSaleIdFilter(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                handleTableChange();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3 col-12">
                                    <input
                                        type="text"
                                        placeholder={t("inputField.placeholder.enterLmUserID")}
                                        className="form-control form-control-sm formsearch-custom ps-2"
                                        value={lmUserIdFilter}
                                        onChange={(e) => setLmUserIdFilter(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                handleTableChange();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3 col-12">
                                    <input
                                        type="text"
                                        placeholder={t("inputField.placeholder.enterShopperName")}
                                        className="form-control form-control-sm formsearch-custom ps-2"
                                        value={nameFilter}
                                        onChange={(e) => setNameFilter(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                handleTableChange();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-lg-2 col-12">
                                    <input
                                        type="text"
                                        placeholder={t(
                                            "inputField.placeholder.enterLMAccountNumber"
                                        )}
                                        className="form-control form-control-sm formsearch-custom ps-2"
                                        value={lmAccountNoFilter}
                                        onChange={(e) => setLmAccountNoFilter(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                handleTableChange();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-auto">
                                    <div className="input-blocks mb-0">
                                        <button
                                            className="btn btn-filters col-auto ms-auto px-2"
                                            style={{ width: "fit-content" }}
                                            onClick={handleTableChange}
                                        >
                                            <i data-feather="search" className="feather-search m-0" />{" "}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <UnlimitTable
                                    pagination={paginationParams.pagination}
                                    columns={columns}
                                    dataSource={designations}
                                    rowKey={(record) => record.id}
                                    loading={loading}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
        </div>
    );
};

export default SalesList;
